<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex md12>
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Boleta de Calificaciones</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-card flat>
                            <v-card-title class="pb-0">
                                <v-layout>
                                    <v-flex sm12 md4>
                                        <v-select
                                                label="Semestre"
                                                :items="semestres"
                                                item-value="periodo"
                                                item-text="nombre"
                                                v-model="semestre"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                            <v-card-text>
                                <v-data-table
                                        :headers="headers"
                                        :items="calificaciones"
                                        hide-actions
                                        v-if="$mq !== 'sm'"
                                >
                                    <template slot="items" slot-scope="props">
                                        <td>
                                            <strong>{{props.item.materia.nombre}}</strong><br>
                                            {{props.item.materia.clave}}
                                        </td>
                                        <td>{{props.item.materia.creditos}}</td>
                                        <td>{{props.item.calificacion}}</td>
                                        <td>{{props.item.tipoEvaluacion}}</td>
                                    </template>
                                </v-data-table>
                                <v-data-iterator
                                        :items="calificaciones"
                                        :rows-per-page-items="[]"
                                        content-tag="v-layout"
                                        row
                                        wrap
                                        v-else-if="$mq === 'sm'"
                                        hide-actions
                                >
                                    <v-flex
                                            slot="item"
                                            slot-scope="props"
                                            xs12
                                            sm6
                                            md4
                                            lg3
                                    >
                                        <v-card>
                                            <v-card-title primary-title>
                                                <div>
                                                    <h4>{{ props.item.materia.nombre }}</h4>
                                                    <div>{{ props.item.materia.clave}}</div>
                                                </div>
                                            </v-card-title>
                                            <v-divider></v-divider>
                                            <v-list dense>
                                                <v-list-tile>
                                                    <v-list-tile-content>Creditos:</v-list-tile-content>
                                                    <v-list-tile-content class="align-end">{{ props.item.materia.creditos }}</v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile>
                                                    <v-list-tile-content>Calificacion:</v-list-tile-content>
                                                    <v-list-tile-content class="align-end">{{ props.item.calificacion }}</v-list-tile-content>
                                                </v-list-tile>
                                                <v-list-tile>
                                                    <v-list-tile-content>Tipo de Evaluación:</v-list-tile-content>
                                                    <v-list-tile-content class="align-end">{{ props.item.tipoEvaluacion }}</v-list-tile-content>
                                                </v-list-tile>
                                            </v-list>
                                        </v-card>
                                    </v-flex>
                                </v-data-iterator>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
                <v-card>
                    <v-card-title>
                        <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                        <v-spacer></v-spacer>
                        <span>Cargando calificaciones</span>
                    </v-card-title>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'BoletaPage',
    created () {
      this.getPeriodos()
    },
    data: () => ({
      cargandoDatos: false,
      headers: [
        {
          text: 'Materia',
          align: 'left',
          sortable: false,
          value: 'materia'
        },
        { text: 'CR', value: 'creditos' },
        { text: 'Calificación', value: 'calificacion' },
        { text: 'Tipo de Evaluacion', value: 'tipoEvaluacion' }
      ],
      semestres: [],
      semestre: null,
      calificaciones: []
    }),
    watch: {
      semestre: function (val) {
        this.getCalificaciones()
      }
    },
    methods: {
      getPeriodos () {
        axios.get('alumno/periodos')
          .then(response => {
            this.semestres = response.data
          })
      },
      getCalificaciones () {
        this.cargandoDatos = true
        axios.post('alumno/calificaciones', { periodo: this.semestre })
          .then(response => {
            this.cargandoDatos = false
            this.calificaciones = response.data
          })
          .catch(() => {
            this.cargandoDatos = false
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/information/BoletaPage.vue